import AdoptabobblesSection from './AdoptabobblesSection';
import AdoptabobblesSectionContainer from './AdoptabobblesSection.container';

export default AdoptabobblesSectionContainer(AdoptabobblesSection);
